<script>
import Icon from "./Icon.vue";

export default {
  components: {Icon},
  props: {
    /**
     * Message Prop - will display the message in the tooltip. Use this to display the message content or the message slot for more control over formatting
     */
    message: {
      type: String,
      required: false
    },
    color: {
      type: String,
      default: "black"
    },
    variant: {
      type: String,
      default: "info",
      validator: (value) => [
        'info',
        'question',
        'warning'
      ].includes(value)
    },
    size: {
      type: String,
      default: "16px",
    },
    position: {
      type: Object,
      default: () => ({
        bottom: '100%',
        left: '50%',
        transform: 'translateX(-50%)'
      })
    },
    tooltipClass: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isVisible: false
    };
  },
  computed: {
    icon() {
      if(this.variant === 'info') return 'info';
      if(this.variant === 'question') return 'question';
      if(this.variant === 'warning') return 'warning-outline';

    }
  },
  methods: {
    showTooltip() {
      this.isVisible = true;
    },
    hideTooltip() {
      this.isVisible = false;
    }
  }
};
</script>

<template>
  <div
    class="tooltip-container"
    @mouseenter="showTooltip"
    @mouseleave="hideTooltip"
  >
    <icon
      :icon="icon"
      :color="color"
      :size="size"
    />
    <div
      v-if="isVisible"
      class="my-tooltip text-sm text-default_white"
      :class="tooltipClass"
      :style="position"
    >
      <div v-if="message">
        {{ message }}
      </div>
      <slot name="message-slot" />
    </div>
  </div>
</template>

<style scoped>
.tooltip-container {
  position: relative;
  display: inline-block;
}
/*
.my-tooltip {
  position: absolute;
  bottom: 100%;
  left: -500%;
  margin-left: 25px;
  transform: translateX(-50%);
  background-color: #333;
  padding: 5px 10px;
  border-radius: 4px;
  min-width: 300px;
  max-width: 400px;
  white-space: normal;

  z-index: 10;
  visibility: visible;
  opacity: 1;
}
*/

.my-tooltip {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  padding: 5px 10px;
  border-radius: 4px;
  width: max-content;
  max-width: min(200px, 80vw);
  white-space: normal;  /* Allow text to wrap */
  z-index: 10;
  visibility: visible; /* Ensure the tooltip is visible */
  opacity: 1;
  margin-bottom: 5px;
}

/* Smaller screens - shift left and reduce size */
@media (max-width: 1920px) {
  .my-tooltip {
    left: 20%;
    transform: translateX(-20%);
    max-width: min(150px, 70vw);
    font-size: 11px;
  }


}

</style>
